import ATVHero from 'assets/images/psp/hero/atv-hero.webp';
import atvTenByTen from 'assets/images/psp/sizeGuide/10x10.svg';
import atvTenByFifteen from 'assets/images/psp/sizeGuide/10x15.svg';
import atvTenByTwenty from 'assets/images/psp/sizeGuide/10x20.svg';
import truckBoatCarContentSectionSVG from 'assets/images/content-section/Illustration-Truck-Boat-Car.svg';
import atvFeatured1 from 'assets/images/psp/FeaturedImages/atv-1.webp';
import atvFeatured2 from 'assets/images/psp/FeaturedImages/atv-2.webp';
import atvFeatured3 from 'assets/images/psp/FeaturedImages/climate1.webp';

const faqs = [
	{
		question: 'Can you store an ATV in a storage unit?',
		answer:
			'Absolutely! Storing your ATV in a storage unit is one of the most popular and practical solutions for ATV owners. Most storage facilities welcome ATVs in their units, and many even specialize in vehicle storage. The key is choosing the right size unit – typically, a 10x10 works for most single ATVs, while larger or multiple ATVs might need a 10x15 or 10x20 unit.\n\n' +
			"Indoor storage units offer the best protection from weather, theft, and vandalism. Your ATV will stay clean, dry, and secure while you're not using it. Many facilities also offer climate-controlled options for premium protection, which is especially valuable for high-end or vintage ATVs.\n\n" +
			"When choosing a storage facility, look for features like wide drive-up access (so you can easily load and unload), good security measures, and convenient access hours. Some facilities even offer covered outdoor parking spaces, which provide weather protection at a lower cost than indoor units. Just make sure to check the facility's specific policies about vehicle storage and any requirements for insurance or registration.",
	},
	{
		question: 'What are the best practices for how to store an ATV?',
		answer:
			'Proper ATV storage starts with a good cleaning. Wash off all mud, dirt, and debris, then let it dry completely to prevent rust and corrosion. Remove the battery and store it in a cool, dry place, or use a battery tender to maintain the charge. Change the oil and filter, and consider using a fuel stabilizer or draining the gas tank entirely for long-term storage.\n\n' +
			"Check and properly inflate all tires, or consider removing the weight by placing the ATV on blocks. This prevents flat spots from developing during extended storage. Grease all fittings and lubricate moving parts according to your owner's manual.\n\n" +
			'Cover your ATV with a breathable cover to protect it from dust while allowing air circulation. Avoid plastic tarps that can trap moisture. If storing outdoors, position it away from direct sunlight and ensure proper drainage around the storage area.\n\n' +
			"For the storage unit itself, choose a clean, dry space with good ventilation. Avoid storing fuel cans in the same unit, and consider using moisture absorbers in humid climates. Document your ATV's condition with photos before storage, and check on it periodically if possible.",
	},
	{
		question: 'Can I work on my ATV in a storage unit?',
		answer:
			"Most storage facilities have strict policies against performing maintenance or repairs in storage units, and for good reason. Storage units typically aren't designed for mechanical work – they lack proper ventilation for fumes, adequate lighting for detailed work, and appropriate drainage for fluids.\n\n" +
			'Additionally, many facilities prohibit activities that could create fire hazards, excessive noise, or strong odors that might disturb other tenants. Using tools, running engines, or storing automotive fluids often violates facility rules and could result in lease termination.\n\n' +
			'However, some facilities do offer workshop spaces or garage-style units specifically designed for vehicle maintenance. These specialty units usually feature better ventilation, electrical outlets, and floor drains. If you need a space to work on your ATV, ask about these options when shopping for storage.\n\n' +
			"For basic maintenance like checking tire pressure or cleaning, most facilities are more lenient, but always check your lease agreement and facility policies first. When in doubt, it's better to perform maintenance at home or find a dedicated workshop space rather than risk violating your storage agreement.",
	},
	{
		question: 'What is vertical ATV storage?',
		answer:
			'Vertical ATV storage refers to storing your ATV in an upright position, typically using specialized racks or lift systems that allow you to maximize storage space by utilizing vertical space. This method is particularly popular in smaller storage units or garages where floor space is limited.\n\n' +
			'There are several types of vertical storage systems available. Some use hydraulic or mechanical lifts to raise the ATV off the ground, while others employ rack systems that allow you to store the ATV on its side or in a tilted position. These systems can be especially useful if you need to store multiple ATVs in the same space or want to leave room for other equipment.\n\n' +
			"However, vertical storage isn't suitable for all ATVs or all situations. It requires proper equipment and installation, and you'll need to consider factors like ceiling height, weight capacity, and accessibility. Some ATV models aren't designed to be stored vertically due to fluid distribution concerns or structural limitations.\n\n" +
			"Before investing in vertical storage, consult your ATV's owner manual and consider the frequency of use. If you need regular access to your ATV, vertical storage might be less convenient than traditional horizontal storage. Most standard storage units work perfectly fine with conventional horizontal storage methods.",
	},
	{
		question: 'How do I winterize my ATV?',
		answer:
			'Winterizing your ATV is crucial for protecting your investment during months of storage. Start by giving your ATV a thorough cleaning to remove all dirt, mud, and debris that could cause corrosion. Pay special attention to the undercarriage and any areas where moisture might collect.\n\n' +
			'Next, focus on the fuel system. Either drain the fuel tank completely or add a high-quality fuel stabilizer and run the engine for a few minutes to circulate the treated fuel through the system. Untreated fuel can gum up carburetors and fuel injectors during storage.\n\n' +
			"Change the engine oil and filter, even if they're not due for replacement. Used oil contains contaminants that can cause damage during extended storage. Remove the battery and store it in a cool, dry place, ideally connected to a battery tender to maintain the charge.\n\n" +
			"Check and properly inflate all tires, or consider removing the weight by placing the ATV on blocks to prevent flat spots. Grease all fittings and lubricate moving parts according to your owner's manual. Finally, cover your ATV with a breathable cover and store it in a dry, well-ventilated area.\n\n" +
			'Before your first ride in spring, reverse the process: reinstall the battery, check all fluids, inspect belts and cables, and take a short test ride to ensure everything is working properly.',
	},
];

const reviews = [
	{
		reviewTitle: 'Problem solved with ease! Oomph, thank heavens!',
		reviewRating: 5,
		reviewText:
			'I was about to store my trailered ATV 40 miles from my house in an unsecured lot, no fence, no cameras! A slight change in search parameters brought me to SpareFoot! Bing, Bang, Boom… Found a perfect place for a perfect price and only 20 miles from home with an easy drive! A prayer answered at the 11th hour! Using the search screen was easy, fast, and successful. See you next summer ATV! I know you’ll be in good hands!',
		reviewerInitials: 'MT',
		link: 'https://www.trustpilot.com/reviews/57d75a950000ff0009874cf6',
		reviewerName: 'Maris',
		reviewDate: 'Sep 16, 2016',
	},
	{
		reviewTitle: 'Site was easy to navigate',
		reviewRating: 5,
		reviewText:
			'SpareFoot site was ready to navigate and had many options. Locations, sizes of units, prices, and discounts.',
		reviewerInitials: 'RV',
		link: 'https://www.trustpilot.com/reviews/6862fe2ccf3a6c04abe409b5',
		reviewerName: 'Rafael Villa',
		reviewDate: 'July 1, 2025',
	},
	{
		reviewTitle: 'Wow!!',
		reviewRating: 5,
		reviewText:
			'I recently moved to California from Texas and needed a place to store my ATV temporarily. After several failed attempts of finding an adequate Self Storage facility on my own, I called SpareFoot and within 5 minutes (literally), they helped me find the perfect, nearby place at an awesome rate. Casey, YOU ROCK!!!',
		link: 'https://www.trustpilot.com/reviews/547ba84c0000640002b840af',
		reviewerInitials: 'RB',
		reviewerName: 'Rick B',
		reviewDate: 'Dec 1, 2014',
	},
	{
		reviewTitle: 'Convenient and easy.',
		reviewRating: 5,
		reviewText:
			'SpareFoot got me a great deal and was extremely convenient and easy to use!',
		reviewerInitials: 'AS',
		link: 'https://www.trustpilot.com/reviews/685ebc497f1c4d5c38cbe2ad',
		reviewerName: 'Ashley',
		reviewDate: 'June 27, 2025',
	},
];

export const ATVContent = {
	type: 'ATV',
	sections: [
		{
			title: 'ATV Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'atv-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best ATV Storage For You',
							description:
								"Your ATV is built for a life of adventure, not taking up half of your garage or sitting under a tarp in your yard. Whether you're dealing with a cramped driveway, a spouse who's tired of bumping into your quad in the garage, or just need somewhere safe to store your ride between epic trail sessions, we get it – ATV storage can be a real headache. \n\n" +
								"SpareFoot makes finding four-wheeler storage as simple as the click of a button. With thousands of storage facilities across the country, we'll help you find a secure and affordable spot where your ATV can rest for the next adventure.",
							image: ATVHero,
							CTAText: 'Find Storage Now',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular ATV Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'ATV Storage Solutions',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'ATV Storage Solutions',
						contentType: 'row-type',
						contentImage: truckBoatCarContentSectionSVG,
						ShowBackgroundImage: true,
						content: [
							' \n\n',
							"Your ATV deserves better than being crammed into whatever space you can find. Whether you're looking to [free up your garage](https://www.sparefoot.com/blog/cluttered-garage), protect your investment from the elements, or just need a secure spot during the off-season, we've got ATV storage unit options that'll keep your ride safe and ready for action. \n\n" +
								'' +
								"From compact utility ATVs to full-size sport four-wheelers, we understand that one size definitely doesn't fit all. That's why we offer flexible ATV storage solutions designed with ATV owners in mind – complete with easy access, security features, and the peace of mind that comes with professional storage. \n\n" +
								' &nbsp; \n\n' +
								"**Pro Tip:** Measure your ATV's length, width, and height before choosing a unit. Don't forget to account for any accessories like plows, winches, or cargo racks that might add to your storage needs!",
						],
					},
				},
			],
		},
		{
			title: 'ATV Storage Size Guide',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'ATV Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n',
							'You might ask yourself, "What size storage unit do I need for my ATV?" The answer, of course, is that it depends.\n\n' +
								'Do you want room in your storage unit for just your ATV, or do you want room to also store accessories and a few other odds and ends? \n\n' +
								'There are a few tried and true ATV storage unit sizes that can hold your small vehicle, and a lot of other stuff. Check out our [helpful storage size guide](https://www.sparefoot.com/storage-unit-size-guide.html) to understand all of your options.',
						],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: 'atv-storage-size-guide',
						headerLinkText: 'Compare Sizes',
						headerLink: '#atv-storage-size-guide',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: atvTenByTen,
								content:
									'### 10x10 Storage Unit\n\n' +
									'**Perfect for:** Most single ATVs, utility quads, and youth models\n\n' +
									'- **Accommodates:** ATVs up to 8 feet long\n\n' +
									'- **Great for:** Standard 4-wheelers, compact utility vehicles\n\n' +
									'- **Bonus space:** Room for helmets, gear, and basic maintenance supplies',
							},
							{
								image: atvTenByFifteen,
								content:
									'### 10x15 Storage Unit\n\n' +
									'**Perfect for:** Larger ATVs or multiple smaller units\n\n' +
									'- **Accommodates:** ATVs up to 12 feet long, or 2 compact ATVs\n\n' +
									'- **Great for:** Sport ATVs, larger utility quads, or one ATV plus accessories\n\n' +
									'- **Bonus space:** Plenty of room for riding gear, spare parts, and tools',
							},
							{
								image: atvTenByTwenty,
								content:
									'### 10x20 Storage Unit\n\n' +
									'**Perfect for:** Multiple ATVs or ATV + trailer combinations\n\n' +
									'- **Accommodates:** 2-3 standard ATVs or 1 ATV with trailer\n\n' +
									'- **Great for:** Families with multiple quads, or storing seasonal equipment together\n\n' +
									'- **Bonus space:** Room for maintenance station, extra tires, and full gear collection',
							},
						],
					},
				},
			],
		},
		{
			title: 'Content section - triple column',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Outdoor ATV Storage vs. ATV Storage Units',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n\n',
							'The ATV storage solutions available are similar to [car storage options](https://www.sparefoot.com/car-storage.html), as you can choose from outdoor ATV storage spots and indoor ATV storage units, depending on your budget and specific storage needs. \n\n' +
								'Outdoor ATV parking is a cheaper storage option offering short-term storage protection and ease of access. Indoor storage for your ATV will cost a little more than outdoor storage, offering a variety of storage unit size options and amenities, like climate control.',
							' \n\n',
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'column-type',
						ShowBackgroundImage: true,
						content: [
							'### Covered Outdoor Parking\n\n' +
								'**Perfect for:** Budget-conscious storage with weather protection\n\n' +
								'- **Accommodates:** Any size ATV\n\n' +
								'- **Great for:** Seasonal storage, easy access needs\n\n' +
								'- **Benefits:** Drive-up convenience, lower cost than indoor units',
							'### Premium Indoor Storage\n\n' +
								'**Perfect for:** High-value ATVs and year-round protection\n\n' +
								'- **Accommodates:** Custom sizing available\n\n' +
								'- **Great for:** Vintage quads, racing ATVs, or prized collections\n\n' +
								'- **Benefits:** Climate control, enhanced security, concierge services',
						],
					},
				},
			],
		},
		{
			title: 'ATV Storage Pricing Guide',
			modules: [
				{
					type: 'content',
					props: {
						title: 'ATV Storage Pricing Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'\n\n',
							"There's an ATV storage solution for every budget. Check out the latest average prices for ATV storage based on unit size, indoor vs outdoor storage, and what you can get for your money.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'atv-storage-pricing',
						headers: [
							{
								label: 'Storage Option',
								key: 'Storage Option',
							},
							{
								label: 'Average Monthly Rate',
								key: 'Average Monthly Rate',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Storage Option': '10x10 Indoor Unit',
								'Average Monthly Rate': '$89/month',
								'Best For': 'Single ATV, compact utility quads',
							},
							{
								'Storage Option': '10x15 Indoor Unit',
								'Average Monthly Rate': '$119/month',
								'Best For': 'Larger ATVs, multiple small units',
							},
							{
								'Storage Option': '10x20 Indoor Unit',
								'Average Monthly Rate': '$149/month',
								'Best For': 'Multiple ATVs, ATV + trailer',
							},
							{
								'Storage Option': 'Covered Outdoor Parking',
								'Average Monthly Rate': '$59/month',
								'Best For': 'Budget storage, seasonal use',
							},
							{
								'Storage Option': 'Premium Indoor Storage',
								'Average Monthly Rate': '$189/month',
								'Best For': 'High-value ATVs, climate control',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n\n',
							'### Additional Fees \n\n' +
								"Your ATV storage unit or outdoor parking space may come with additional one-time fees in addition to your monthly rate. Be on the lookout for these fees to avoid any surprises when it's time to check in to your unit.\n\n" +
								'- **One-time setup fee:** $25 average\n\n' +
								"- **Security deposit:** Typically equates to one month's rent\n\n" +
								'- **Insurance required** (or proof of existing coverage)',
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Why You Should Use SpareFoot To Find ATV Storage',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'ATV Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'How to Store It',
								date: 'October 2, 2025',
								image: atvFeatured1,
								content:
									'Complete ATV Winterization Guide: How to Store Your ATV for Winter [Downloadable Checklist]',
								link: 'https://www.sparefoot.com/blog/atv-winterization-guide',
							},
							{
								title: 'General Storage Advice',
								date: 'September 3, 2024',
								image: atvFeatured2,
								content:
									'What Can You Fit Inside of a 10×20 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/10x20-storage-unit-size-guide',
							},
							{
								title: 'General Storage Advice',
								date: 'September 22, 2025',
								image: atvFeatured3,
								content:
									'What Are Climate-Controlled Storage Units?',
								link: 'https://www.sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'Motorcycle',
							'DirtBike',
							'RV',
							'GolfCart',
							'DriveUp',
							'24Hour',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
